<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>市场开发</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="16">
      <el-col :span="24">
      <!-- 数据管理 -->
      <el-card style="margin-top: 15px">
        <el-row class="title_row">
          <el-col>
            <span class="title_class">数据管理</span>
          </el-col>
        </el-row>
        <el-row :gutter="15" style="margin-top: 34px">
          <el-col
            :span="6"
            v-for="(item, i) of dataManagementList"
            v-bind:key="i"
          >
            <div
              class="racing-tool-back"
              @click="racingToolClicked(item.path)"
            >
              <div
                class="racing-tool-leftimg"
                :class="'coloricon' + item.menuTag"
              >
                <i class="icon iconfont" :class="item.icon"></i>
              </div>
              <div class="racing-tool-right">
                <div>{{ item.rightTitle }}</div>
                <div class="racing-tool-desc">{{ item.rightDesc }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-card>
      </el-col>
      <el-col :span="24">
      <!-- 待处理事务 -->
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">报名信息管理</span>
            </el-col>
          </el-row>
          <el-row :gutter="15" style="margin-top: 34px">
            <el-col
              :span="6"
              v-for="(item, i) of processedList"
              v-bind:key="i"
            >
              <div
                class="racing-tool-back"
                @click="racingToolClicked(item.path)"
              >
                <div
                  class="racing-tool-leftimg"
                  :class="'coloricon' + item.menuTag"
                >
                  <i class="icon iconfont" :class="item.icon"></i>
                </div>
                <div class="racing-tool-right">
                  <div>{{ item.rightTitle }}</div>
                  <div class="racing-tool-desc">{{ item.rightDesc }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  data () {
    return {
      activeName: 'first',
      dataManagementList: [
        {
          icon: 'icon-xuexiao_xuexiaoxinxi',
          rightTitle: '学校管理',
          rightDesc: '可新增学校，修改学校信息',
          path: '/system_data_Management/system_school_infomation',
          menuTag: '1'
        },
        {
          icon: 'icon-saichejingsu',
          rightTitle: '学校注册审核',
          rightDesc: '注册信息审核',
          path: '/b_data_Management/b_school_management?tab=1',
          menuTag: '2'
        }
      ],
      processedList: [
        {
          icon: 'icon-dkw_shenhezhong',
          rightTitle: '报名信息',
          rightDesc: '报名信息审核、管理',
          path: '/b_data_Management/b_match_list',
          menuTag: '3'
        },
        {
          icon: 'icon-shenqingguanli',
          rightTitle: '签到管理',
          rightDesc: '队伍签到管理',
          path: '/b_data_Management/b_match_list?type=signin',
          menuTag: '4'
        }
      ]
    }
  },
  created () {
    this.getData()
  },
  methods: {
    handleClick (tab, event) {
      if (tab._props.name === 'first') {
        // console.log('11111')
        this.$refs.directRef.initCharts()
      } else {
        // console.log('22222')
        this.$refs.directRef.initCharts()
      }
    },
    racingToolClicked (path) {
      if (path) {
        this.$router.push({ path })
      }
    },
    getData () {
      // 待处理事务
      // pendingMatter({ activityType: this.$chnEngStatusCode.activityType }).then(res => {
      //   if (res.code === 200) {
      //     Object.keys(res.data).forEach(key => {
      //       this.processedList.find(item => item.key === key).number = res.data[key]
      //     })
      //   }
      // })
    }
  }
}
</script>

<style lang="less" scoped>
.real-time-backview {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .real-time-item {
    width: 50%;
    display: flex;
    margin-bottom: 20px;
    flex-direction: column;
    .real-time-title {
      width: 100%;
      font-size: 14px;
      color: #333;
      margin-bottom: 8px;
    }
    .real-time-desc {
      width: 100%;
      font-size: 24px;
      color: #1e96f1;
      span{
        font-size: 14px;
        color: #333;
      }
    }
  }
}
.racing-tool-back {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}

// .racing-tool-leftimg {
//   width: 50px;
//   height: 60px;
//   margin-right: 5px;
// }

// .racing-tool-right {
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   font-size: 16px;
//   color: rgb(107, 107, 107);
// }
// .data-tool-leftimg {
//   width: 60px;
//   height: 60px;
//   border-radius: 10px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin-right: 5px;
// }
// .data-tool-img {
//   width: 35px;
//   height: 35px;
//   filter: grayscale(100%) brightness(0%) invert(100%);
// }

// .racing-tool-desc {
//   font-size: 12px;
// }
.redcolor {
  color: red;
}
.data-statistics-title {
  font-size: 14px;
  color: rgb(107, 107, 107);
}
.data-statistics-desc {
  font-size: 18px;
  color: rgb(65, 65, 65);
  font-weight: 900;
}
.processed-list-con{
  height: 138px;
}
</style>
